<template>
    <ModalComponent
        :name="'editar-email-' + email.id"
        title="Editar email"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Email" name="email" type="email" id="email" rules="required|email" v-model="email.email" />
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['email'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(editado) {
                this.$emit('close', 'editar-email-' + this.email.id, editado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editar();
                }
            },
            editar() {
                this.loading = true;

                const params = {
                    filters : {},
                    email: this.email.email,
                    email_id: this.email.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.emails.editar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
